import { get, post } from './common'

export namespace user {
  export function getUserInfo() {
    return get<ApiTypes.DataResult<ServerData.UserData>>('/user/info', {})
  }

  export function getExchangeCode(code: string) {
    return post<ApiTypes.DataResult<unknown> & { version: 'noce' | 'vip' }>(
      '/exchange_code/post',
      {},
      { code }
    )
  }

  export function getLoginQr() {
    return get<ApiTypes.DataResult<ServerData.LoginQrCodeData>>('/auth/register_qr', {
      kword: sessionStorage.getItem('kword') || undefined,
      utm: sessionStorage.getItem('utm') || undefined,
    })
  }

  export function checkQrLogin(sceneId: string) {
    return get<ApiTypes.DataResult<ServerData.CheckQrLoginData>>('/auth/register_qr/check', {
      sceneId,
    })
  }

  export function postUserActionRecord(data: PostData.UserActionInfo) {
    return post('/user_behavior/burying', {}, data)
  }

  export function logout() {
    return get('/user/logout')
  }

  export function getActivity() {
    return get<ApiTypes.DataListResult<ServerData.ActivityData[]>>('/activity/list', {})
  }
}
